import React, { useEffect, useMemo, useState } from 'react'

import { Button, Select } from 'antd'

import { getApiTargetInfo } from 'core'
import {
  getUtilityNameMap,
  getUnitNameMap,
  getPermitActions,
  getEnvConfig,
} from 'core/selectors'
import UtilityUnitSelection from 'core/component/UtilityUnitSelection'

import { Label } from 'core/screen-util'
import { SppAcaUnitsHeaders } from './ACAHeaders'
import {
  deleteUnitTypeInfoByUnit,
  getUnitTypeInfo,
  getUnitTypeInfoByUnit,
  postUnitTypeInfoByUnit,
} from './acaapi'
import { connect } from 'react-redux'
import CommonScreen from 'admin/component/CommonScreen'
import { toSelectionColProps } from '@integec/grid-tools'

const ACAReportUnits = props => {
  const [insertEvent, setInsertEvent] = useState(false)

  const [unitTypeList, setUnitTypelist] = useState([])
  useEffect(() => {
    getUnitTypeInfo(props.apiTargetInfo).fork(console.log, res => {
      setUnitTypelist(res.map(ut => ut.sppUnittype))
    })
  }, [props.apiTargetInfo])

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '150px 400px 100px 350px   150px 100px 150px',
          gap: 5,
        }}
      >
        <Label>Select Utility/Unit : </Label>
        <UtilityUnitSelection
          utility={insertData.utility}
          unit={insertData.unitId}
          onUnitChange={value => {
            // setUtilityUnit(value)
            setInsertData({
              ...insertData,
              utility: value[0],
              unit: value[1].substr(3),
              unitId: value[1],
            })
          }}
          casStyle={{ marginLeft: '5px' }}
        />
        <Label>SPP Unit Type :</Label>
        <Select
          // style={{ width: '150px' }}
          value={insertData.sppUnittype}
          onChange={value =>
            setInsertData({ ...insertData, sppUnittype: value })
          }
        >
          {unitTypeList.map(ut => (
            <Select.Option key={ut} value={ut}>
              {ut}
            </Select.Option>
          ))}
        </Select>

        <div style={{ gridColumnEnd: 'span 3' }}>
          <Button type="primary" onClick={() => onAdd(true)}>
            Add
          </Button>

          <Button
            type="primary"
            onClick={() => onAdd(false)}
            style={{ marginLeft: '20px' }}
          >
            Add & Hide
          </Button>
          <Button
            type="danger"
            onClick={onCancel}
            style={{ marginLeft: '20px' }}
          >
            Cancel
          </Button>
        </div>
      </div>
    )
  }

  const headerWithFormatter = useMemo(
    _ =>
      SppAcaUnitsHeaders.map(header =>
        header.ident === 'utility'
          ? {
              ...header,
              // ...toSelectionColProps(utilityNameMap),
              dataFormatter: ({ value }) =>
                value + ' - ' + props.utilityNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                props.utilityNameMap[rowData.utility] || rowData.utility,
            }
          : header.ident === 'unitId'
          ? {
              ...header,
              // choices: [],
              dataFormatter: ({ value, rowData }) =>
                rowData.unit + ' - ' + props.unitNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                props.unitNameMap[rowData.unitId] || rowData.unitId,
            }
          : header.ident === 'sppUnittype'
          ? { ...header, ...toSelectionColProps(unitTypeList) }
          : header
      ),
    [props.unitNameMap, props.utilityNameMap, unitTypeList]
  )

  return (
    <CommonScreen
      title="SPP ACAP Report Units"
      header={headerWithFormatter}
      initialSortOptions={SppAcaUnitsHeaders}
      saveTask={postUnitTypeInfoByUnit}
      retrieveTask={getUnitTypeInfoByUnit}
      deleteTask={deleteUnitTypeInfoByUnit}
      altBy={d => d.unitId}
      autoRetrieve
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={30}
      withImport
      importUrl="aepaca/unittypes-by-unit/import"
      importData={{ importType: 'ACAP_UNIT_BY_UNITTYPE' }}
      importSucessRetrieve
      // widthOffset={550}
      // heightOffset={100}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  permitActions: getPermitActions(state),
  envConfig: getEnvConfig(state),
})

export default connect(mapStateToProps)(ACAReportUnits)
